<template>
  <div class="vue-sidebar">
    <div class="sidebar-wrap">
      <div class="sidebar-content" v-if="pathname === '' || pathname === '#'">
        <button id="close-sidebar" @click="closeSidebar()">X</button>
        <LoginSidebar v-if="mode === 'login'" @close="closeSidebar()" @state="viewPathname()"/>
        <!-- <RegisterSidebar v-if="mode === 'register'" @register="showModal" /> -->
        <ForgotSidebar v-if="mode === 'forgot'" @close="closeSidebar()" @changeMode="changeMode($event)"/>
        <!-- <a class="logo_dnie" @click="dniAccess()"><img src="@/assets/img/logo_dnie.jpg" alt="logo icasal"></a> -->
        <a v-if="mode === 'login'" @click="mode = 'forgot'">Olvidé mi contraseña</a>
        <a v-if="mode === 'forgot'" @click="mode = 'login'">Ya tengo cuenta</a>
        <!-- <a v-if="mode === 'login'" @click="mode = 'register'" @close="closeSidebar()">Nuevo usuario</a> -->
        <div class="btn-certificado"><a href="https://www.icasal.com/zonaprivada-backend/api/loginAca">ACCESO CERTIFICADO ACA</a></div>
      </div>
      <div class="sidebar-content" v-if="pathname === '#confirmReset'">
        <button id="close-sidebar" @click="closeSidebar()">X</button>
        <ConfirmSidebar @close="closeSidebar()" @changeMode="changeMode($event)"/>
      </div>
      <!-- <div class="logo-icasal">
        <img src="@/assets/img/logo_icasal.png" alt="logo icasal">
      </div> -->
    </div>
    <SharedNotification />
  </div>
</template>

<script>
// Services
import LoginSidebar from '@/components/LoginSidebar.vue';
// import RegisterSidebar from '@/components/RegisterSidebar.vue';
import ForgotSidebar from '@/components/ForgotSidebar.vue';
import ConfirmSidebar from '@/components/ConfirmSidebar.vue';
import SharedNotification from '@/shared/SharedNotification.vue';
import CONSTS from '@const/plugin.constants'

import JQuery from 'jquery';
const $ = JQuery;

export default {
  name: 'vue-sidebar',
  el: '#vue-sidebar',
  data() {
    return {
      notif: {},
      mode: 'login',
      openModal: false,
      pathname: '',
      credentialsModal: {},
      urlWeb: CONSTS.BASE_WEB
    }
  },
  created() {
    this.viewPathname();
  },
  methods: {
    closeSidebar() {
      window.location.href = window.location.href.split("?")[0];
      this.mode = 'login';
      document.querySelector('#auth_sidebar').style.display = 'none';
      this.viewPathname();
    },
    changeMode(event) {
      window.location.hash = '';
      // window.location.href = window.location.href.split("?")[0] ? window.location.href.split("?")[0] : window.location.href.split("#")[0];
      this.pathname = '';
      this.mode = event;
    },
    viewPathname() {
      const checkUrl = window.location.hash.split("?");
      this.pathname = checkUrl[0];
    },
    showNotification(event) {
      this.notif = event
    },
    showModal(event) {
      this.openModal = true;
      this.credentialsModal = event;
    },
    dniAccess() {
      $.ajax({
          type: "GET",
          url: 'https://dniicasaldev.undanet.com/dniaccess',
          async:true,
          dataType : 'jsonp', //you may use jsonp for cross origin request
          crossDomain:true,
          success: function(data) {
            window.open(this.urlWeb + '#/login?token=' + data.token + '&user=aflores&pass=undanet2015', '_blank')
          }
      });
    }
  },
  components: {
    LoginSidebar,
    // RegisterSidebar,
    ForgotSidebar,
    ConfirmSidebar,
    SharedNotification
  }
}
</script>

<style>
  .btn-certificado{
    margin-top: 30px;
    text-align: center;
  }

  .btn-certificado > a{
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 800 !important;
    font-family: Roboto Slab,sans-serif;
    text-decoration: none !important;
    padding: 12px 0;
    background: #9d2f22;
  }
</style>
